module.exports = __webpack_public_path__ + "static/img/duofanghuiyi2.4e26eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/duofanghuiyi2.png
// module id = durq
// module chunks = 24